import instance from "../../utils/axios";
import qs from "qs"; // npm install qs

const API_BASE_URL = "/churches/coverimage";

// ✅ Save Church Cover Image

export const saveChurchCoverImageApi = async (payload) => {
    const required = ["_id", "galleryObjId"];
    for (const key of required) {
      if (!payload[key]) throw new Error(`Missing field: ${key}`);
    }
  
    // Convert payload to x-www-form-urlencoded format
    const formBody = qs.stringify(payload);
  
    const response = await instance.post(`${API_BASE_URL}/save`, formBody, {
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    });
  
    return response.data;
  };
  
  export const updateChurchCoverImageApi = async (payload) => {
    const required = ["_id", "galleryObjId"];
    for (const key of required) {
      if (!payload[key]) throw new Error(`Missing field: ${key}`);
    }
  
    const formBody = qs.stringify(payload);
  
    const response = await instance.post(`${API_BASE_URL}/update`, formBody, {
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    });
  
    return response.data;
  };
// ✅ Delete Church Cover Image
export const deleteChurchCoverImageApi = async (payload) => {
    const required = ["_id", "coverimageObjId"];
    for (const key of required) {
      if (!payload[key]) throw new Error(`Missing field: ${key}`);
    }
  
    const formBody = qs.stringify(payload);
  
    const response = await instance.post(`${API_BASE_URL}/delete`, formBody, {
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    });
  
    return response.data;
  };
  